import { Button, Icon } from 'antd';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { emptyFn } from 'utils/common';
import { tryPatchSharedValues } from '../flow/actions';

const defaultProps = {
  tryPatchSharedValues: emptyFn
};
const propTypes = {
  activeFolder: PropTypes.object.isRequired,
  tryPatchSharedValues: PropTypes.func
};

class Actions extends PureComponent {
  handleSaveClick = () => {
    const { activeFolder, tryPatchSharedValues } = this.props;
    if (!_.isEmpty(activeFolder)) {
      const { sharedToUsers, sharedToTeams, type } = activeFolder;
      tryPatchSharedValues(activeFolder.id, type, {
        share_to_users: sharedToUsers.map(u => u.id),
        share_to_teams: sharedToTeams.map(t => t.id)
      });
    }
  };

  render() {
    const { activeFolder } = this.props;
    const shouldDisabled = _.isEmpty(activeFolder) || !!activeFolder.sharedBy;
    return (
      <Button
        onClick={this.handleSaveClick}
        className="mt-md"
        disabled={shouldDisabled}
      >
        <Icon type="save" className="font-sm" />
        <FormattedMessage id="global.ui.button.save" />
      </Button>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  tryPatchSharedValues
};
Actions.defaultProps = defaultProps;
Actions.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Actions);



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/components/Actions.jsx